/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
(function( $ ) {
	
	var Faq = {};
	
	Faq.toggle = function( answer ) {
		if( answer.is( ':visible' ) ) {
			answer.slideUp();
			
			return;
		}
		
		answer.slideDown();
	};

	$( document ).ready( function() {
		$( '.accordion-item .show-slide' ).click( function( e ) {
			e.preventDefault();
			
			var parent = $( this ).parent( '.accordion-item' );
			
			Faq.toggle( parent.find( '.answer' ) );
		} );
	} );
	
})( jQuery );